import { useEffect, useState } from "react";
import { selectAccountAgeVerificationStatus, selectAgeVerificationLimitationStatus, useSelector } from "@jti/store";
export const useAgeVerification = () => {
    const [isAgeVerificationError, setIsAgeVerificationError] = useState(false);
    const isAgeVerificationRequired = useSelector(selectAgeVerificationLimitationStatus);
    const accountAgeVerificationStatus = useSelector(selectAccountAgeVerificationStatus);
    useEffect(() => {
        if (isAgeVerificationRequired && accountAgeVerificationStatus !== null) {
            setIsAgeVerificationError(!accountAgeVerificationStatus);
        }
    }, [accountAgeVerificationStatus, isAgeVerificationRequired]);
    return { isAgeVerificationError };
};
//# sourceMappingURL=useAgeVerification.js.map